module.exports = __webpack_public_path__ + "static/media/Discord-Logo.bd62f7f5.svg";